import { render } from "./MyDelete.vue?vue&type=template&id=5f5859ec&scoped=true"
import script from "./MyDelete.vue?vue&type=script&lang=js"
export * from "./MyDelete.vue?vue&type=script&lang=js"

import "./MyDelete.vue?vue&type=style&index=0&id=5f5859ec&scoped=true&lang=css"

import exportComponent from "D:\\main\\spacelab\\cinema-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f5859ec"]])

export default __exports__